"use strict";

exports.__esModule = true;
exports.AuthContext = void 0;
var _AuthController = require("./AuthController");
var _Utils = require("../../../Utils");
/**
 * Provides a auth context to consumers
 * @component
 */
var AuthContext = exports.AuthContext = (0, _Utils.createEnhancedContext)({
  propName: "auth",
  defaultController: _AuthController.AuthController
});